import { z } from 'zod';

export const incidentFormSchema = z.object({
  name: z.string()
    .min(1, "Please enter your name")
    .max(45, "Name must be 45 characters or less"),
  
  email: z.email("Please enter a valid email address")
    .min(1, "Please enter your email address")
    .max(45, "Email must be 45 characters or less"),
  
  system: z.string()
    .min(1, "Please select a system"),
  
  priority: z.string()
    .min(1, "Please select a priority level"),
  
  impact: z.string()
    .min(1, "Please select an impact level"),
  
  category: z.string()
    .min(1, "Please select a category"),

  issueType: z.string()
    .min(1, "Please select an issue type"),

  subject: z.string()
    .min(20, "Short description must be at least 20 characters")
    .max(200, "Short description must be 200 characters or less"),
  
  comments: z.string()
    .min(1, "Please enter your comments")
    .max(8000, "Comments must be 8000 characters or less"),

}).refine((data) => {
  const subjectWithCategory = `${data.category}: ${data.subject}`;
  return subjectWithCategory.length <= 50;
}, {
  message: "Short Description Including Category is too long",
  path: ["subject"]
});

export const priorityOptions = [
  { value: "4", label: "Low" },
  { value: "3", label: "Medium" },
  { value: "2", label: "High" },
  { value: "1", label: "Critical" },
];

export const impactOptions = [
  { value: "4", label: "Minor/Low" },
  { value: "3", label: "Moderate/Limited" },
  { value: "2", label: "Significant/Large" },
  { value: "1", label: "Extensive/Widespread" },
];

export const categoryOptions = [
  { value: "Account Issue", label: "Account Issue" },
  { value: "Order Issue", label: "Order Issue" },
  { value: "Card Issue", label: "Card Issue" },
  { value: "Payment Issue", label: "Payment Issue" },
  { value: "Bulk Cancel", label: "Bulk Cancel" },
  { value: "Invoice/Credit", label: "Invoice/Credit" },
  { value: "Billing/Discount", label: "Billing/Discount" },
  { value: "User/Access", label: "User/Access" },
  { value: "API Issue", label: "API Issue" },
  { value: "File Issue", label: "File Issue" },
  { value: "Report Issue", label: "Report Issue" },
  { value: "Finance Issue", label: "Finance Issue" },
];
